var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 28.3334H12.7779C12.4832 28.3334 12.2006 28.2163 11.9922 28.0079C11.7838 27.7996 11.6667 27.5169 11.6667 27.2222V15C11.6667 14.7053 11.7838 14.4227 11.9922 14.2144C12.2006 14.006 12.4832 13.8889 12.7779 13.8889H18.3334V15H12.7779V27.2222H25.0001V21.6667H26.1112V27.2222C26.1112 27.5169 25.9941 27.7996 25.7858 28.0079C25.5774 28.2163 25.2948 28.3334 25.0001 28.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6667C19.8527 11.6667 19.7114 11.7253 19.6072 11.8295C19.503 11.9337 19.4445 12.075 19.4445 12.2223C19.4445 12.3696 19.503 12.511 19.6072 12.6151C19.7114 12.7193 19.8527 12.7779 20 12.7779H26.4389L18.7445 20.4723C18.6863 20.5221 18.6391 20.5834 18.6057 20.6523C18.5724 20.7212 18.5537 20.7963 18.5507 20.8728C18.5478 20.9493 18.5606 21.0256 18.5886 21.0969C18.6165 21.1682 18.6589 21.233 18.713 21.2871C18.7672 21.3413 18.8319 21.3836 18.9032 21.4115C18.9745 21.4395 19.0508 21.4524 19.1273 21.4494C19.2038 21.4465 19.2789 21.4277 19.3478 21.3944C19.4167 21.361 19.478 21.3138 19.5278 21.2556L27.2223 13.5612V20.0001C27.2223 20.1474 27.2808 20.2887 27.385 20.3929C27.4892 20.4971 27.6305 20.5556 27.7778 20.5556C27.9252 20.5556 28.0665 20.4971 28.1707 20.3929C28.2748 20.2887 28.3334 20.1474 28.3334 20.0001V11.6667H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoutIcon);
export default __webpack_public_path__ + "static/media/popout-icon.44f5070b6b042e4c2e5cad5f37f0c673.svg";
export { ForwardRef as ReactComponent };